import React from 'react'
import { Line } from 'react-chartjs-2'
import { ChartOptions } from 'chart.js'
import { ChartContainer, ChartTitle } from './ModelTrainingView.styles'
import { Model } from '../../../types/models/model'
import { TrainingJobEntryClassification } from '../../../types/models/model'

interface AccuracyMetricsChartProps {
  model: Model | undefined
}

const AccuracyMetricsChart: React.FC<AccuracyMetricsChartProps> = ({ model }) => {
  const metricsChartOptions: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: '#fff',
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        ticks: {
          color: '#aaa',
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.1)',
        },
      },
      y: {
        ticks: {
          color: '#aaa',
        },
        grid: {
          color: 'rgba(255, 255, 255, 0.1)',
        },
        min: 0,
        max: 1,
      },
    },
  }

  const getAccuracyChartData = (model: Model | undefined) => {
    if (!model?.training_stats?.classification?.training_job_metrics) {
      return {
        labels: [],
        datasets: [],
      }
    }

    const firstJobKey = Object.keys(
      model.training_stats?.classification?.training_job_metrics || {}
    )[0]
    if (!firstJobKey) {
      return { labels: [], datasets: [] }
    }

    const jobEntries =
      model.training_stats?.classification?.training_job_metrics[firstJobKey].training_job_entries

    return {
      labels: jobEntries.map(
        (entry: TrainingJobEntryClassification) => `Epoch ${(entry.epoch || 0) + 1}`
      ),
      datasets: [
        {
          label: 'Accuracy',
          data: jobEntries.map((entry: TrainingJobEntryClassification) => entry.accuracy || 0),
          originalData: jobEntries.map(
            (entry: TrainingJobEntryClassification) => entry.accuracy || 0
          ),
          borderColor: 'rgba(13, 202, 240, 1)',
          backgroundColor: 'rgba(13, 202, 240, 0.2)',
          tension: 0.4,
        },
      ],
    }
  }

  const chartData = getAccuracyChartData(model)

  return (
    <ChartContainer>
      <ChartTitle>Training Accuracy</ChartTitle>
      <div style={{ width: '100%', aspectRatio: '16/9' }}>
        <Line data={chartData} options={metricsChartOptions} />
      </div>
    </ChartContainer>
  )
}

export default AccuracyMetricsChart
